import React, { useState } from "react";
import MainHome from "../../components/MainHome";
import { useTranslation } from "react-i18next";
import { useToast } from "../../common/contexts/useToast";
import useUserStore from "../../common/store/user.store";
import { sysConfig } from "../../config";
import CustomDropdown from "../../components/common/inputs/CustomDropdown";
import "../../styles/components/SettingsPage.scss";
import CustomChipInput from "../../components/common/inputs/CustomChipInput";
import { updateUserSettings } from "../../common/api/apiCalls";

const Settings = () => {
  const { user } = useUserStore();
  const { t } = useTranslation();
  const { showToast } = useToast();

  const [systemLanguage, setSystemLanguage] = useState<string>("English");
  const [chipOptions, setChipOptions] = useState<string[]>(user?.predefinedEmails || []);
  const [currentChipValue, setCurrentChipValue] = useState<string>("");

  const languageArr = sysConfig.LANGUAGE_OPTIONS.map((option) => option.label);

  const handleAddChip = () => {
    if (!currentChipValue.trim()) return;
  
    const isCommaSeparated = currentChipValue.includes(",");
  
    const newEmails = currentChipValue
      .split(",") 
      .map((email) => email.trim())
      .filter((email) => email !== "");
  
    
    const invalidEmails = newEmails.filter(
      (email) => !sysConfig.EMAIL_PATTERN.test(email)
    );

    const invalidFormat = newEmails.map(email => email.split("@")?.length > 2);

    if (!isCommaSeparated && newEmails.length > 1 || invalidFormat.includes(true)) {
      showToast("error", "Error", t("general.errors.invalidEmailsChip"));
      return;
    }
  
    if (invalidEmails.length > 0) {
      showToast("error", "Error", t("general.errors.emailNotValidChip"));
      return;
    }
  
    const updatedChips = Array.from(new Set([...chipOptions, ...newEmails]));
    setChipOptions(updatedChips);
    setCurrentChipValue("");
    submitPredefinedEmails(updatedChips);
  };

  const handleRemoveChip = (chip: string) => {
    const updatedChips = chipOptions.filter((e) => e !== chip);
    setChipOptions(updatedChips);
    submitPredefinedEmails(updatedChips);
  };

  const submitPredefinedEmails = async (emails:string[]) => {
    await updateUserSettings({ systemLanguage, predefinedEmails: emails });
    showToast("success", "Success", t("settings.emailUpdated"));
  };

  return (
    <MainHome>
      <div className="settings-container">
        <div className="settings-card">
          <div className="settings-header">
            <h1 className="settings-title">{t("menu.settings")}</h1>
          </div>
          <div className="settings-divider"></div>
          
          <div className="settings-section language-section">
            <div className="section-content">
              <div className="section-header">
                <h2 className="section-title">{t("settings.siteLanguage")}</h2>
                <p className="section-description">{t("settings.siteLanguageDescription")}</p>
              </div>
              <div className="section-input">
                <CustomDropdown
                  name={"language"}
                  label={""}
                  optionsArray={languageArr}
                  value={systemLanguage}
                  handleInputChange={(e: any) => setSystemLanguage(e.target.value)}
                  showDefaultOption={false}
                />
              </div>
            </div>
          </div>
          
          <div className="settings-divider"></div>
          
          <div className="settings-section email-section">
            <div className="section-content">
              <div className="section-header">
                <h2 className="section-title">{t("settings.emailList")}</h2>
                <p className="section-description">{t("settings.emailListDescription")}</p>
              </div>
              <CustomChipInput
                placeHolder=""
                chipOptions={chipOptions}
                currentValue={currentChipValue}
                setCurrentValue={setCurrentChipValue}
                onAddChip={handleAddChip}
                onRemoveChip={handleRemoveChip}
                isInfoMessage={false}
                className="settings-email-input"
              />
            </div>
          </div>
        </div>
      </div>
    </MainHome>
  );
};

export default Settings;
